var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { ReplaySubject } from "rxjs";
import log from "./log";
export class FileTransferImpl {
    constructor(id, userId, userEndpointId, interactionId, conferenceId, targetType, targetId, mimeType, filename, sentAt, signedUrlProvider) {
        this.id = id;
        this.userId = userId;
        this.userEndpointId = userEndpointId;
        this.interactionId = interactionId;
        this.conferenceId = conferenceId;
        this.targetType = targetType;
        this.targetId = targetId;
        this.mimeType = mimeType;
        this.filename = filename;
        this.sentAt = sentAt;
        this.signedUrlProvider = signedUrlProvider;
        this.refreshing = false;
    }
    static create(fileTransferId, userId, userEndpointId, options, signedUrlProvider) {
        return new FileTransferImpl(fileTransferId, userId, userEndpointId, options.interactionId, options.conferenceId, options.targetType, options.targetId, options.blob.type, options.filename, new Date(), signedUrlProvider);
    }
    static createFromEvent(event, signedUrlProvider) {
        return new FileTransferImpl(event.fileTransferId, event.userId, event.userEndpointId, event.interactionId, event.conferenceId, event.targetType, event.targetId, event.mimeType, event.filename, new Date(event.timestamp), signedUrlProvider);
    }
    static createFromDTO(dto, signedUrlProvider) {
        return new FileTransferImpl(dto.fileTransferId, dto.userId, dto.userEndpointId, dto.interactionId, dto.conferenceId, dto.targetType, dto.targetId, dto.mimeType, dto.filename, new Date(dto.sentAt), signedUrlProvider);
    }
    get signedUrl() {
        if (!this.refreshing && (this.isExpired() || !this.mSignedUrl)) {
            this.refreshSignedUrl();
        }
        return this.mSignedUrlObservable;
    }
    isExpired() {
        var _a;
        return (((_a = this.mSignedUrl) === null || _a === void 0 ? void 0 : _a.expires) &&
            Date.now() >= this.mSignedUrl.expires.getTime());
    }
    refreshSignedUrl() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this.refreshing = true;
                if (!this.mSignedUrlObservable || this.mSignedUrlObservable.isStopped) {
                    this.mSignedUrlObservable = new ReplaySubject(1);
                }
                this.mSignedUrl = yield this.signedUrlProvider.get(this.id);
                this.mSignedUrlObservable.next(this.mSignedUrl.url);
            }
            catch (error) {
                log.error(`error getting signed url for filetransfer id ${this.id}`, error);
                this.mSignedUrlObservable.error(error);
            }
            finally {
                this.refreshing = false;
            }
        });
    }
}
